import { Box } from '@mui/material'
import React from 'react'

export default function RegisterNavbar() {
  return (
    <Box sx={{
      height: "72px",
      display: "flex",
      paddingTop: "16px",
      paddingRight: "40px",
      paddingBottom: "16px",
      paddingLeft: "40px",
      background: "#FFFFFF",
      alignItems: "center",
      position: "sticky",
      top: "0",
      zIndex: "100",
      boxShadow: "-2px 2px 5px 0px #00000040"
    }}>

      <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Logo" />
      <h1
        style={{
          marginLeft: "12px",
          fontWeight: "700",
          marginTop: "7px",
          fontSize: '32px',
          fontFamily: "Roboto",
          color: "#111214",
        }}>
        RouteEye
      </h1>

    </Box>
  )
}
